import httpClient from './httpClient';

export const AUTH_SESSION_KEY = 'flamex.auth.logged_in';
export const AUTH_LAST_ACTIVITY_KEY = 'flamex.auth.last_activity_at';
export const AUTH_LOGOUT_REASON_KEY = 'flamex.auth.logout_reason';
export const SESSION_IDLE_TIMEOUT_MS = 10 * 60 * 1000;

export function markAuthActivity(timestamp = Date.now()) {
  localStorage.setItem(AUTH_LAST_ACTIVITY_KEY, String(timestamp));
  return timestamp;
}

export function getLastAuthActivity() {
  const raw = localStorage.getItem(AUTH_LAST_ACTIVITY_KEY);
  const parsed = Number(raw);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
}

export function setLogoutReason(reason) {
  if (!reason) {
    localStorage.removeItem(AUTH_LOGOUT_REASON_KEY);
    return;
  }
  localStorage.setItem(AUTH_LOGOUT_REASON_KEY, String(reason));
}

export function consumeLogoutReason() {
  const reason = localStorage.getItem(AUTH_LOGOUT_REASON_KEY);
  localStorage.removeItem(AUTH_LOGOUT_REASON_KEY);
  return reason;
}

export async function login(email, senha) {
  const response = await httpClient.post('/auth/login', {
    email: String(email ?? '').trim(),
    senha,
  });
  localStorage.setItem(AUTH_SESSION_KEY, '1');
  localStorage.removeItem(AUTH_LOGOUT_REASON_KEY);
  markAuthActivity();
  return response.data;
}

export async function logout() {
  try {
    await httpClient.post('/auth/logout');
  } finally {
    localStorage.removeItem(AUTH_SESSION_KEY);
    localStorage.removeItem(AUTH_LAST_ACTIVITY_KEY);
  }
}

export async function getUsuarioLogado() {
  const hasLoginState = localStorage.getItem(AUTH_SESSION_KEY) === '1';
  if (!hasLoginState) {
    throw new Error('Nao autenticado');
  }

  try {
    const response = await httpClient.get('/auth/me');
    return response.data;
  } catch (error) {
    if (error?.response?.status === 401 || error?.response?.status === 403) {
      localStorage.removeItem(AUTH_SESSION_KEY);
    }
    throw error;
  }
}

function extractApiMessage(error) {
  const message = error?.response?.data?.message;
  return typeof message === 'string' && message.trim() ? message.trim() : '';
}

export function getLoginErrorFeedback(error) {
  const status = error?.response?.status;
  const apiMessage = extractApiMessage(error);

  if (status === 401) {
    return {
      title: 'Acesso negado',
      message: apiMessage || 'Confira suas credenciais e tente novamente.',
    };
  }

  if (status === 400) {
    return {
      title: 'Dados invalidos',
      message: apiMessage || 'Revise o email e a senha informados.',
    };
  }

  if (!error?.response) {
    return {
      title: 'Servidor indisponivel',
      message: 'Nao foi possivel conectar ao sistema no momento.',
    };
  }

  return {
    title: 'Falha ao entrar',
    message: apiMessage || 'O servidor retornou um erro inesperado.',
  };
}
export const forgotPassword = async (email) => {
  const n8nWebhook = "https://n8nflamex.dratelecom.com.br/webhook/6d99bcb3-e53e-4cb8-9be2-71782beb2a33";

  try {
    const response = await fetch(n8nWebhook, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email: email }),
    });
    if (!response.ok) {
      throw new Error("Falha ao enviar recuperação")
    }
    return await response.json();
  } catch (error) {
    console.error("Erro no serviço forgotPassword", error);
    throw error;
  }
}